import { useCurrentUser } from '@/contexts/current-user-context';
import { useTranslation } from '@/contexts/i18n-context';
import { useBranding } from '@/outlets/branding-outlet';
import { Button, ButtonColor, ButtonVariant } from '@/components/button';

interface LogoutButtonProps {
  className?: string;
  onClick?: () => void;
  fullWidth?: boolean;
  variant?: ButtonVariant;
  color?: ButtonColor;
}

export function LogoutButton({ className, onClick, fullWidth, variant, color }: LogoutButtonProps) {
  const { logout } = useCurrentUser();
  const { t } = useTranslation();
  const { logoutUrl, logoutText, refetch } = useBranding();

  const handleLogout = () => {
    logout();
    refetch();
    onClick?.();
  };

  const logoutLabel = logoutText ?? t('header.logout');

  return (
    <Button
      className={className}
      variant={variant}
      color={color}
      fullWidth={fullWidth}
      {...(logoutUrl
        ? { as: 'a', to: logoutUrl, onClick }
        : { as: 'button', onClick: handleLogout })}
    >
      {logoutLabel}
    </Button>
  );
}
